import actions from '../actions-list';

export const resetMetrics = metrics =>

    dispatch => {

        dispatch({
            metrics,
            type: actions.RESET_OPEN_PIP_PROGRAMS_REPORT_METRICS
        });

    };



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/reset-metrics.js